module.exports = __webpack_public_path__ + "img/48ce2dc.webp";